export class ZeroEtlIdentityColumnSpec {
    'field';
    'columnName';
    'partition';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ZeroEtlIdentityColumnField",
            "format": ""
        },
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        },
        {
            "name": "partition",
            "baseName": "partition",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ZeroEtlIdentityColumnSpec.attributeTypeMap;
    }
    constructor() {
    }
}
